var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ab-container" },
    [
      _vm._t("default"),
      _vm._v(" "),
      !_vm.formCreateInject.rule.originChildren.length
        ? _c("div", { staticClass: "ab-empty" }, [
            _c("div", [_vm._v("可拖拽添加多个字段")]),
            _vm._v(" "),
            _c("span", [_vm._v("(不支持明细中添加明细字段)")]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }